<template>
  <div>
    <PageAllow controller="MaterialSales" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherOrderDate
              v-model="options"
              show-radio
              show-radio-actual
              show-radio-pay
              show-radio-expect
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-btn
              v-show="materialSales.length"
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSparkline')"
            >
              {{
                $store.state.showSparklinePanel
                  ? $t("App.hideSparkline")
                  : $t("App.showSparkline")
              }}
              <v-icon small class="ps-1">{{
                $store.state.showSparklinePanel
                  ? "fa-angle-up"
                  : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn small color="print" dark @click.stop="exportExcel()">
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel", [$t("Nav.materialSalesDetails")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterial v-model="materialsSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherAlliances v-model="alliancesSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherShops
                  v-model="shopsSelected"
                  :allianceBusinessIds="options.alliance_business_ids"
                />
              </v-col>
              <!-- 分组 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  settings && settings.report_hide_search_district_tree == 2
                "
              >
                <SearcherDistrictsWithDescendants
                  v-model="DistrictsSelected"
                  :label="
                    $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <SearcherOrderOriginFlgs v-model="options.origin_flgs" />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <SearcherOrderStatus v-model="options.status" />
              </v-col>
              <!-- 商品销售类型 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherSingleStatus
                  mandatory
                  v-model="options.auto_flg"
                  :label="$t('auto_flg.ObjectName')"
                  :items="$consts.autoFlg"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- <v-expansion-panel
          v-show="sparklineValues.length > 1"
          class="transparent-background-color"
        >
          <v-expansion-panel-content>
            <BarSparkline :labels="sparklineLabels" :values="sparklineValues" />
          </v-expansion-panel-content>
        </v-expansion-panel> -->
        <v-expansion-panel
          v-show="sparklineValues.length"
          class="transparent-background-color"
        >
          <v-expansion-panel-content>
            <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="materialSales"
          :page.sync="current_page"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td :colspan="settings && settings.report_hide_search_district_tree == 1 ? 7 : 8">
                <v-btn
                  v-if="settings && settings.report_hide_search_district_tree == 1"
                  small
                  outlined
                  color="info"
                  class="px-2 me-2"
                  :disabled="!districtID"
                  @click.stop="$emit('to-parent-district')"
                >
                  <v-icon x-small class="pe-1">fa-reply</v-icon>
                  {{ $t("District.return") }}
                </v-btn>
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{ materialSalesTotalNum | formatTwoDot }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ materialSalesTotalPrice | formatMoney }}</span
                >
              </td>
              <!-- <td></td> -->
              <!-- <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{
                  material_distribution_total_num | formatTwoDot
                }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ material_distribution_total_price | formatMoney }}</span
                >
              </td> -->
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <v-btn
                    v-if="settings && settings.report_hide_search_district_tree == 1"
                    small
                    outlined
                    color="info"
                    class="px-2"
                    :disabled="!districtID"
                    @click.stop="$emit('to-parent-district')"
                  >
                    <v-icon x-small class="pe-1">fa-reply</v-icon>
                    {{ $t("District.return") }}
                  </v-btn>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.totalNum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ materialSalesTotalNum | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.totalPrice") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ materialSalesTotalPrice | formatMoney }}
                </div>
              </td>
              <!-- <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("MaterialSales.TableHeaders.distribution_total_sum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ material_distribution_total_num | formatTwoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{
                    $t("MaterialSales.TableHeaders.distribution_total_price")
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money")
                  }}{{ material_distribution_total_price | formatMoney }}
                </div>
              </td> -->
            </tr>
          </template>

          <template v-slot:header.title="{ header }">
            <v-icon x-small>fa-map-marked-alt</v-icon>
            {{ header.text }}
            <v-icon x-small>fa-store</v-icon>
          </template>
          <template v-slot:item.title="{ item }">
            <span
              :class="!item.shop_name ? 'info--text' : ''"
              @click.stop="
                if (!item.shop_name) $emit('change-district', item.district);
              "
            >
              <v-icon :color="!item.shop_name ? 'info' : ''" x-small>{{
                typeof item.shop_name == "undefined"
                  ? "fa-map-marked-alt"
                  : "fa-store"
              }}</v-icon>
              {{
                typeof item.shop_name == "undefined"
                  ? item.district.name
                  : item.shop_name
              }}
              <v-icon
                :color="!item.shop_name ? 'info' : ''"
                v-if="!item.shop_name"
                x-small
                >fa-angle-double-right</v-icon
              >
            </span>
          </template>
          <template v-slot:item.standard_name="{ item }">
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </template>
          <template v-slot:item.average_price="{ item }"
            >{{ $t("Global.money") }}
            {{ (item.total_price / item.total_sum) | formatMoney }}</template
          >
          <template v-slot:item.total_sum="{ item }">{{
            item.total_sum | formatTwoDot
          }}</template>
          <template v-slot:item.total_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.total_price | formatMoney }}</template
          >
          <!-- 配送均价 -->
          <!-- <template v-slot:item.distripution_average_price="{ item }"
            >{{ $t("Global.money") }}
            {{
              item.distribution_price_sum == 0
                ? 0
                : (item.distribution_num_sum / item.distribution_price_sum)
                  | formatMoney
            }}
          </template> -->
          <!-- 配送量 -->
          <!-- <template v-slot:item.distribution_num_sum="{ item }">{{
            item.distribution_num_sum | formatTwoDot
          }}</template> -->
          <!-- 配送金额 -->
          <!-- <template v-slot:item.distribution_price_sum="{ item }"
            >{{ $t("Global.money") }}
            {{ item.distribution_price_sum | formatMoney }}</template
          > -->
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
// import BarSparkline from "@/components/plugins/BarSparkline";
import BarEcharts from "@/components/plugins/BarEcharts";
import SearcherOrderDate from "@/components/plugins/SearcherOrderDate";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherOrderStatus from "@/components/plugins/SearcherOrderStatus";
import SearcherOrderOriginFlgs from "@/components/plugins/SearcherOrderOriginFlgs";
import SearcherSingleStatus from "@/components/plugins/SearcherSingleStatus";
import Materials from "@/api/materials";
import MaterialSales from "@/api/material_sales";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  orderDatetimeRadios: "radio-created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  pay_time_from: "",
  pay_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  alliance_business_ids: [],
  shop_ids: [],
  status: [1, 2, 3, 4, 5, 6],
  origin_flgs: [],
  sortBy: [],
  sortDesc: [],
  auto_flg: 0,
  district_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    // BarSparkline,
    BarEcharts,
    SearcherOrderDate,
    SearcherMaterial,
    SearcherAlliances,
    SearcherShops,
    SearcherOrderStatus,
    SearcherOrderOriginFlgs,
    SearcherSingleStatus,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialSales"),
        disabled: false,
        href: "/material-sales",
      },
      {
        text: i18n.t("Nav.materialSalesDetails"),
        disabled: true,
        href: "",
      },
    ],
    headers() {
      var headers = []
      if (this.settings &&
        this.settings.report_hide_search_district_tree == 1) {
        headers.push(
          {
          text: i18n.t("MaterialSales.TableHeaders.title"),
          align: "start",
          sortable: false,
          value: "title",
          },)
      } else if (this.settings &&
        this.settings.report_hide_search_district_tree == 2)
      { 
        headers.push(
          {
            text: i18n.t("MaterialSales.TableHeaders.shop_code", [
              this.$consts.shopName(),
            ]),
            align: "start",
            sortable: false, 
            value: "shop_code", 
          },
          {
            text: i18n.t("MaterialSales.TableHeaders.shop_name", [
              this.$consts.shopName(),
            ]),
            align: "start",
            sortable: false,
            value: "shop_name",
          },)
      }
      headers.push(
        {
          text: i18n.t("MaterialSales.TableHeaders.materialCode"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.materialName"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.averagePrice"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.unit"),
          align: "center",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.totalNum"),
          align: "end",
          sortable: false,
          value: "total_sum",
        },
        {
          text: i18n.t("MaterialSales.TableHeaders.totalPrice"),
          align: "end",
          sortable: false,
          value: "total_price",
        },
        // 配送均价
        // {
        //   text: i18n.t("MaterialSales.TableHeaders.distripution_average_price"),
        //   align: "end",
        //   sortable: false,
        //   value: "distripution_average_price",
        // },
        // // 配送量
        // {
        //   text: i18n.t("MaterialSales.TableHeaders.distribution_total_sum"),
        //   align: "end",
        //   sortable: false,
        //   value: "distribution_num_sum",
        // },
        // // 配送金额
        // {
        //   text: i18n.t("MaterialSales.TableHeaders.distribution_total_price"),
        //   align: "end",
        //   sortable: false,
        //   value: "distribution_price_sum",
        // },
      )
      return headers;
    },
    sparklineLabels() {
      return this.materialSales.map((materialSale) => {
        return materialSale.shop_name
          ? materialSale.shop_name
          : materialSale.district.name;
      });
    },
    sparklineValues() {
      return this.materialSales.map((materialSale) => {
        return parseFloat(materialSale.total_price);
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "districtID", "settings"]),
  },

  mounted() {
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.getMaterialFromAPI();
    this.$commonUtils
      .loadOptions("material-sales", [
        "alliancesSelected",
        "shopsSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = Object.assign({}, data.options, {
              auto_flg: this.$route.query.auto_flg
                ? parseInt(this.$route.query.auto_flg)
                : 0,
            });
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    materialsSelected: null,
    alliancesSelected: [],
    shopsSelected: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    current_page: 1,
    materialSales: [],
    materialSalesTotalNum: 0,
    materialSalesTotalPrice: 0,
    material_distribution_total_num: 0,
    material_distribution_total_price: 0,
    DistrictsSelected: [],
  }),

  methods: {
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.$store.commit("districtID", 0);
    },
    onSearch() {
      this.getMaterialSalesFromAPI();
    },
    getMaterialFromAPI() {
      Materials.fetchOne(this.$route.params.material_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialsSelected = response.data.material;
          }
        }.bind(this)
      );
    },
    getMaterialSalesFromAPI() {
      var options = Object.assign({}, this.options, {
        auto_flg: isNaN(this.options.auto_flg) ? -1 : this.options.auto_flg,
      });
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MaterialSales.fetchOne(this.$route.params.material_id, options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialSales = response.data.districts_material_sales;
            this.materialSalesTotalNum = response.data.material_sales_total_num;
            this.materialSalesTotalPrice =
              response.data.material_sales_total_price;
            this.material_distribution_total_num =
              response.data.material_distribution_total_num;
            this.material_distribution_total_price =
              response.data.material_distribution_total_price;
            this.current_page = 1; //这个接口不做后台分页，因此每次获取后切换回第一页
          }
        }.bind(this)
      );
    },
    exportExcel() {
      var options = Object.assign({}, this.options, {
        auto_flg: isNaN(this.options.auto_flg) ? -1 : this.options.auto_flg,
      });
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MaterialSales.exportOne(this.$route.params.material_id, options);
    },
  },

  watch: {
    $route() {
      this.$store.commit(
        "searchDistrict",
        this.settings && this.settings.report_hide_search_district_tree == 1
          ? true
          : false
      );
      this.getMaterialSalesFromAPI();
    },
    districtID: {
      handler() {
        this.getMaterialSalesFromAPI();
      },
    },
    materialsSelected: {
      handler() {
        if (
          this.materialsSelected &&
          this.materialsSelected.id != this.$route.params.material_id
        ) {
          this.$router.replace("/material-sales/" + this.materialsSelected.id);
        }
      },
    },
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected.map(
          (alliance) => {
            return alliance.id;
          }
        );
        sessionStorage.setItem(
          "material-sales-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected.map((shop) => {
          return shop.id;
        });
        sessionStorage.setItem(
          "material-sales-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getMaterialSalesFromAPI();
        sessionStorage.setItem(
          "material-sales-options",
          JSON.stringify(this.options)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2
        )
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "material-sales-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>